import { call } from 'redux-saga/effects';
import { SignalingSocket } from 'services/signaling';
import { createPollRequested } from 'features/polls/actions';

export function* createPollSaga(action: ReturnType<typeof createPollRequested>) {
  yield call(SignalingSocket.send, { event: 'createPoll', data: action.payload });
}
